<template>
  <b-form ref="form" >
    <div class="row">
      <div class="row col-12 pr-0 mb-3">
        <Select
          autoload
          moduleName="webcrawler"
          endpoint="getAll"
          textField="source"
          valueField="_id"
          placeholder="Type"
          label="Website"
          v-model="model.type"
          :name.sync="model.type"
          class="col-12 pr-0"
        />
      </div>
    </div>
  </b-form>
</template>

<script>
import Select from '@components/form2/select'

export default {
  components: {
    Select
  },
  data () {
    return {
      model: {
        type: ''
      }
    }
  }
}
</script>